import type { ChatMapMarker } from 'tripPlanner/components/ChatMap/types'
import {
  isValidCoordinate,
  MARKER_TYPE_CHAT_EXPERIENCE,
  MARKER_TYPE_CHAT_HOTEL,
  MARKER_TYPE_ITEM,
  MARKER_SOURCE_ITINERARY,
  type MapMarkerComponent,
} from 'tripPlanner/utils/mapMarkerTransforms'

interface DrawerMapSubject {
  marker: ChatMapMarker | undefined
  placeId: string
  itemId?: number
  offerId?: string
  offerType?: 'hotel' | 'experience'
}

/** The compact view is the full saved itinerary plus its current subject. */
export function buildDrawerMapMarkers(itineraryMarkers: Array<MapMarkerComponent>, subject: DrawerMapSubject): {
  markers: Array<MapMarkerComponent>
  focusedItemId?: number
  focusedMarker?: MapMarkerComponent
} {
  const savedItems = itineraryMarkers.filter(marker => marker.itemId !== undefined && isValidCoordinate(marker))
  const matchingItems = savedItems.filter(marker => subject.offerId
    ? marker.offerId === subject.offerId
    : marker.placeId === subject.placeId)
  let savedSubject: MapMarkerComponent | undefined
  if (subject.itemId !== undefined) {
    savedSubject = savedItems.find(marker => marker.itemId === subject.itemId)
  } else if (matchingItems.length === 1) {
    savedSubject = matchingItems[0]
  } else {
    savedSubject = matchingItems.find(marker => marker.lat === subject.marker?.lat && marker.lng === subject.marker?.lng)
  }

  if (!subject.marker || !isValidCoordinate(subject.marker) || savedSubject) {
    return { markers: savedItems, focusedItemId: savedSubject?.itemId, focusedMarker: savedSubject }
  }

  const focal: MapMarkerComponent = {
    lat: subject.marker.lat,
    lng: subject.marker.lng,
    label: subject.marker.label ?? subject.marker.name,
    markerId: subject.offerId ?? subject.placeId,
    offerId: subject.offerId,
    placeId: subject.offerId ? undefined : subject.placeId,
    markerType: subject.offerId
      ? subject.offerType === 'experience' ? MARKER_TYPE_CHAT_EXPERIENCE : MARKER_TYPE_CHAT_HOTEL
      : MARKER_TYPE_ITEM,
    source: MARKER_SOURCE_ITINERARY,
  }
  return { markers: [...savedItems, focal], focusedMarker: focal }
}
